export default "__VITE_PUBLIC_ASSET__b7ad0b9c__"